<template>
    <div class="error-page ff-bold text-center p-4 flex flex-col w-full h-full justify-center items-center">
        <div class="ff-reg font-15 text-gray text-center w-full">
            พบปัญหาในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง
        </div>
        <div class="mt-4 w-full">
            <PrimaryButton @click="clickTryAgain">
                {{ lbl.buttons.tryAgain }}
            </PrimaryButton>
        </div>
    </div>
</template>
<script>
import { Encrypt } from '@/core/Encrypt/Encrypt'
import useLocaleStore from "../store/LocaleStore";
// component
import PrimaryButton from "@/module/Bitkub/component/Button/PrimaryButton.vue";

export default {
    name: "OAuthError",
    components: { PrimaryButton },
    data: function () {
        return {
            appState: null,
            fromCache: false,
        };
    },
    setup: function () {
        const LocaleStore = useLocaleStore()

        return {
            lbl: LocaleStore.lbl,
            LocaleStore
        }
    },
    mounted: function () {
        this.init();
    },
    methods: {
        init: function () {
            this.restoreState();
            this.initLocale();
            // console.log(this.appState)
        },
        restoreState: function () {
            // check state
            let urlState = this.$route.query.state || null;
            if (urlState != null) {
                // restore from oauth state
                this.appState = JSON.parse(urlState);
                this.fromCache = false
            }
            else {
                // restore from sessionStorage
                let rawState = sessionStorage.getItem("bzbs.state");
                this.appState = JSON.parse(rawState);
                this.fromCache = true
            }
        },
        initLocale: function () {
            if (this.appState != null) {
                let json = this.decryptQueryStringToObj(this.appState)
                const localeCode = json.locale || 1054;
                this.LocaleStore.setters.setLocale(localeCode);
            }
            // console.log(this.lbl)
        },
        decryptQueryStringToObj: function (state) {
            const encryptor = new Encrypt()
            if (this.fromCache) {
                let raw = encryptor.decryptQueryString(decodeURIComponent(state.data), state.module)
                let json = JSON.parse(decodeURIComponent(raw))
                return json
            } else {
                let raw = encryptor.decryptQueryString(state.data, state.module)
                let json = JSON.parse(decodeURIComponent(raw))
                return json
            }
        },
        clickTryAgain: function () {
            if (this.appState.module != null) {
                if (this.appState.module == "yescoin") {
                    let queryParams = this.decryptQueryStringToObj(this.appState)
                    this.yesCoinHandler(queryParams);
                }
                else if (this.appState.module == "bitkub") {
                    let queryParams = this.decryptQueryStringToObj(this.appState)
                    this.bitkubHandler(queryParams);
                }
            }
        },
        //#region handler
        yesCoinHandler: function (data) {
            // let qs = this.objectToQueryString(data)
            this.$router.replace({
                path: "/yescoin",
                query: {
                    ...data,
                }
            });
        },
        bitkubHandler: function (data) {
            // let qs = this.objectToQueryString(data)
            this.$router.replace({
                path: "/bitkub",
                query: {
                    ...data,
                }
            });
        }
        //#endregion
    },
}
</script>
<style lang="scss" scoped>
@import "@/module/Bitkub/style/main.scss";
@import "@/module/Bitkub/style/base.scss";

.error-page {
    @extend %base-class;
}

.text-bitkub {
    color: $bitkub;
}

.text-gray {
    color: $gray;
}

.h-full {
    height: 100vh;
}
</style>